import { FinanceAccountMoveMoneyFormContainer } from '../../../../containers';

export const FinanceAccountMoveMoneyForm = () => {
  return <FinanceAccountMoveMoneyFormContainer />;
};
